import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, UntypedFormControl, Validators } from '@angular/forms';
import { AUTH_SERVICE, AuthService } from '../../services/auth.service';
import TYPES from '../../constants/types';
import { InputComponent } from "../../components/input/input.component";

import { ButtonComponent } from '../../components/button/button.component';
import { TranslatePipe } from '@ngx-translate/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatInputModule } from "@angular/material/input";
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-register',
  imports: [
    ReactiveFormsModule,
    ButtonComponent,
    InputComponent,
    TranslatePipe,
    MatDatepickerModule,
    MatInputModule
],
  templateUrl: './register.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './register.component.scss'
})
export class RegisterComponent {
  
  registerForm: FormGroup;
  BUTTON_TYPES: any;
  INFO_SCREEN: any;
  emailControl: UntypedFormControl;
  passwordControl: UntypedFormControl;
  passwordVerificationControl: UntypedFormControl;
  isRegisterButtonDisabled:boolean;
  inviteEmail: string | null;

  private authService: AuthService = inject(AUTH_SERVICE);

  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private route: ActivatedRoute
  ) {
    this.inviteEmail = this.route.snapshot.queryParamMap.get('inviteEmail');

    this.emailControl = new UntypedFormControl(this.inviteEmail ?? '', [Validators.required, Validators.email]);
    this.passwordControl = new UntypedFormControl('', [Validators.required, Validators.minLength(6)]);
    this.passwordVerificationControl = new UntypedFormControl('', [Validators.required]);
    
    this.registerForm = this.formBuilder.group({
      email: this.emailControl,
      password: this.passwordControl,
      passwordVerification: this.passwordVerificationControl,
    });

    this.passwordVerificationControl.addValidators(()=> {
      return this.passwordControl.value === this.passwordVerificationControl.value ? null : { passwordMismatch: true };
    });

    this.isRegisterButtonDisabled = this.registerForm.invalid;
    this.registerForm.statusChanges.subscribe(
      (event => {
        this.isRegisterButtonDisabled = this.registerForm.invalid;
      })
    );

    this.BUTTON_TYPES = TYPES.UI.BUTTON;
    this.INFO_SCREEN = TYPES.UI.INFO_SCREEN;

  }

  async signUpWithEmail() {
    if(!this.isFormInvalid()){ 
      const error = await this.authService.signUpWithEmail(
        this.registerForm.value.email, 
        this.registerForm.value.password
      );

      if(error === null){
        this.router.navigate([
          '/info', 
          this.INFO_SCREEN.ACCOUNT_CREATED, 
          'info.account_created', 
          'info.verify_email', 
          'info.thanks_secure',
          'buttons.resend_email'
        ], { replaceUrl: true, queryParams: { email: this.registerForm.value.email } });
      }

    }else{
      this.registerForm.markAllAsTouched();
      this.registerForm.updateValueAndValidity();
    }
  }

  cancel()  {
    history.back();
  }

  isFormInvalid(): boolean{
    return this.registerForm.invalid
  }

}
